import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { GeneralConfirmationModalResult } from "../../models";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: 'cpf-cancellation-contract-modal',
  templateUrl: './cancellation-contract-modal.component.html',
  styleUrls: ['./cancellation-contract-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CancellationContractModalComponent {
  public selectedDate: Date | null = null;
  public petName = '';
  public GeneralConfirmationModalResult = GeneralConfirmationModalResult;

  constructor(public dialogRef: MatDialogRef<CancellationContractModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: { petName: string }
  ) {
    this.petName = data?.petName;
  }

  close(result: GeneralConfirmationModalResult | Date) {
    this.dialogRef.close(result);
  }
}
